export type DashboardTourStepId =
  | "welcome"
  | "cockpit"
  | "overview_nav"
  | "overview_page"
  | "workspace_nav"
  | "workspace_page"
  | "pages_nav"
  | "pages_page"
  | "settings_nav"
  | "settings_page"
  | "forms_nav"
  | "forms_page"
  | "deployments_nav"
  | "deployments_page"
  | "domains_nav"
  | "domains_page"
  | "usage_nav"
  | "usage_page"
  | "translation_nav"
  | "translation_page"
  | "glossary_nav"
  | "glossary_page"
  | "seo_nav"
  | "seo_page"
  | "complete";

export const DASHBOARD_TOUR_STEP_ORDER: DashboardTourStepId[] = [
  "welcome",
  "cockpit",
  "overview_nav",
  "overview_page",
  "workspace_nav",
  "workspace_page",
  "pages_nav",
  "pages_page",
  "settings_nav",
  "settings_page",
  "forms_nav",
  "forms_page",
  "deployments_nav",
  "deployments_page",
  "domains_nav",
  "domains_page",
  "usage_nav",
  "usage_page",
  "translation_nav",
  "translation_page",
  "glossary_nav",
  "glossary_page",
  "seo_nav",
  "seo_page",
  "complete",
];

export type DashboardTourStatus =
  | "not_started"
  | "active"
  | "paused"
  | "skipped"
  | "dismissed"
  | "completed";

export type DashboardTourPauseReason =
  | "editor_handoff"
  | "site_required"
  | null;

export interface DashboardTourSessionState {
  schemaVersion: 1;
  userId: string;
  tenantId: string;
  sessionId: string;
  status: DashboardTourStatus;
  currentStep: DashboardTourStepId;
  startedAt: string | null;
  lastActivityAt: string | null;
  completedAt: string | null;
  pauseReason: DashboardTourPauseReason;
}

export function createInitialDashboardTourSession(
  userId: string,
  tenantId: string,
  sessionId: string,
): DashboardTourSessionState {
  return {
    schemaVersion: 1,
    userId,
    tenantId,
    sessionId,
    status: "not_started",
    currentStep: "welcome",
    startedAt: null,
    lastActivityAt: null,
    completedAt: null,
    pauseReason: null,
  };
}

export function parseStoredDashboardTourSession(
  raw: unknown,
): DashboardTourSessionState | null {
  if (!raw || typeof raw !== "object") return null;

  const obj = raw as Partial<DashboardTourSessionState>;
  if (obj.schemaVersion !== 1) return null;
  if (typeof obj.userId !== "string" || obj.userId.length === 0) return null;
  if (typeof obj.tenantId !== "string" || obj.tenantId.length === 0) {
    return null;
  }
  if (typeof obj.sessionId !== "string" || obj.sessionId.length === 0) {
    return null;
  }
  if (typeof obj.status !== "string") return null;
  if (typeof obj.currentStep !== "string") return null;
  if (
    !DASHBOARD_TOUR_STEP_ORDER.includes(obj.currentStep as DashboardTourStepId)
  ) {
    return null;
  }

  return {
    schemaVersion: 1,
    userId: obj.userId,
    tenantId: obj.tenantId,
    sessionId: obj.sessionId,
    status: obj.status as DashboardTourStatus,
    currentStep: obj.currentStep as DashboardTourStepId,
    startedAt: obj.startedAt ?? null,
    lastActivityAt: obj.lastActivityAt ?? null,
    completedAt: obj.completedAt ?? null,
    pauseReason:
      obj.pauseReason === "editor_handoff" ||
      obj.pauseReason === "site_required"
        ? obj.pauseReason
        : null,
  };
}
